import { useCallback } from 'react';
import { cleanHtmlValue, createMarkup } from '@utils';
import { getGroupElementComponent } from '../helpers';

export const FormGroupComponent = (props) => {
  const { schema, form, handleGroupChange } = props;
  const { components } = schema;

  const handleInputChange = useCallback(
    (key) => (event) => handleGroupChange(key, cleanHtmlValue(event.currentTarget.value)),
    [handleGroupChange]
  );

  const handleCheckboxChange = useCallback(
    (key) => (event) => handleGroupChange(key, event.currentTarget.checked),
    [handleGroupChange]
  );
  const handleDateChange = useCallback(
    (key) => (date) => handleGroupChange(key, date),
    [handleGroupChange]
  );

  return (
    <>
      {components.map((component) => {
        const { key, style, label, properties, value, prefixText, type } = component;

        const element = getGroupElementComponent({
          schema: component,
          formSchema: schema,
          type,
          form,
          value,
          handleCheckboxChange,
          handleInputChange,
          handleDateChange,
          key,
          prefixText,
          properties,
        });

        return (
          <div key={key} style={style}>
            <div dangerouslySetInnerHTML={createMarkup(label)}></div>
            {element}
          </div>
        );
      })}
    </>
  );
};
